export default "__VITE_ASSET__C46Cm6ON__"